<template>
  <div class="findShopWrap">
    <div class="fd_banner">
      <img src="//assets.lepucdn.cn/vue/images/zhuanti/images/findShopbg_03.png" alt />
    </div>
    <div class="whyFindShop">
      <p>为什么来乐铺找店？</p>
    </div>
    <div class="fd_con">
      <div class="fdCon_item">
        <div class="con_itemLeft">01
            <img src="//assets.lepucdn.cn/vuetest/images/zhuanti/images/title2_06.png" alt />
        </div>
        <div class="con_itemRight">
            <span class="line"></span>
            <p>
                 每日新上500+
                <span>独家</span>真实铺源，大部分都是58上没有的
            </p>
        </div>
      </div>
      <div class="fdCon_item">
        <div class="con_itemLeft">02
            <img src="//assets.lepucdn.cn/vuetest/images/zhuanti/images/title3_06.png" style="padding-top:.04rem;box-sizing:border-box" alt />
        </div>
        <div class="con_itemRight">
            <span class="line"></span>
            <p>
                人工核验商铺6项证照，专人实地拍摄
                <span>店铺视频</span>
            </p>
        </div>
      </div>
      <div class="fdCon_item">
        <div class="con_itemLeft">03
            <img src="//assets.lepucdn.cn/vuetest/images/zhuanti/images/title3_03.png" alt />
        </div>
        <div class="con_itemRight">
            <span class="line"></span>
            <p>
                所有铺源均为
                <span>房东直租</span>
            </p>
        </div>
      </div>
    </div>
    <div class="fd_login">
      <h2>
        <i class="iconfont icon-shouzhi-copy"></i>登录乐铺，查看全城店铺
      </h2>
      <p style="font-weight: 600;">{{mobile}}</p>
      <div class="login_ipt">
        <input class="ipt" type="text" placeholder="输入验证码" v-model="codeNum" />
        <span :class="['getYz',disabled?'codeBg':'']" @click="getCode" :disabled="disabled">{{codetext}}</span>
      </div>
      <button class="login_btn" @click="login_btn">登录</button>
    </div>
    <p class="findShop_tip">
      搜索"<span>乐铺</span>"公众号，获取全城最新店铺信息
    </p>
    <Loading v-if="isLoading"></Loading>
  </div>
</template>
<script>
import Loading from "@/components/Loading.vue"
import qs from 'qs'
export default{
    name: "findShop",
    data(){
        return{
            disabled:false,
            codetext: '获取验证码',
            timer: null,
            count: '',
            codeNum: '',
            sms_code: '',
            mobile: null,
            isLoading:true
        }
    },
    components:{
        Loading
    },
    methods: {
        getData(){
            this.ajax.get('//api.lepu.cn/app/activity/demand-sms?sms_code='+this.sms_code).then(res=>{
                var res = res.data
                this.isLoading = false
                if(res.data.code == 1){
                    this.mobile = res.data.mobile
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        getCode(){
            this.getCodeRequest()
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.disabled = true;
                this.timer = setInterval(() => {
                    if (this.count > 1 && this.count <= TIME_COUNT) {
                        this.count--;
                        this.codetext = '倒计时'+this.count+'s'
                    } else {
                        this.disabled = false
                        clearInterval(this.timer);
                        this.timer = null;
                        this.codetext = '获取验证码'
                    }
                }, 1000)
            }
        },
        getCodeRequest(){
            this.ajax.post('//api.lepu.cn/usercenter/captcha',qs.stringify({mobile:this.mobile})).then(res=>{
                var res = res.data
                if(res.status == 1){

                }else{
                    this.disabled = false
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                    clearInterval(this.timer)
                }
            })
        },
        login_btn(){
            this.isLoading = true
            this.ajax.post('//api.lepu.cn/usercenter/login',qs.stringify({mobile:this.mobile,verifiycode:this.codeNum})).then(res=>{
                var res = res.data
                this.isLoading = false
                if(res.status){
                    location.href = '//m.lepu.cn'
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        }
    },
    created(){
        console.log(this.$route.query)
        if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.sms_code != 'undefined' && this.$route.query.sms_code != undefined){
            this.sms_code = this.$route.query.sms_code
        }
        this.getData()
    },
}
</script>
<style lang="scss" scoped>
input{
    border: none;
    outline:none;
    -moz-appearance:none;
    -webkit-appearance : none ;/*解决ios上按钮的圆角问题*/
    border-radius: 0;/*解决ios上输入框圆角问题*/
    outline:medium;/*去掉鼠标点击的默认黄色边框*/
    background-color: transparent;
}

.findShopWrap {
  width: 100%;
  height: 100%;
}

.fd_banner {
  width: 100%;
  height: 2.9rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.whyFindShop {
  width: 100%;
  height: 1rem;
  text-align: center;
  margin-top: 0.5rem;

  p {
    display: inline-block;
    padding: 0.06rem 0.14rem;
    box-sizing: border-box;
    margin: 0 auto;
    font-size: 0.3rem;
    color: #333;
    background-image: linear-gradient(to right, #fdeb77, #fffef8);
  }
}

.codeBg{
    background: #ccc!important;
}

.fd_con {
  width: 100%;
  padding: 0 0.4rem;
  box-sizing: border-box;

  .fdCon_item {
    width: 100%;
    margin-bottom: 0.2rem;

    .con_itemLeft {
      font-size: 0.4rem;
      color: #c90524;
      font-family: "Arial Black";
      margin-right: 0.1rem;
      width: 100%;
      display: flex;
      align-items: center;

        img {
          width: 1.2rem;
          height: auto;
          margin-left: .1rem;
        }
    }

    .con_itemRight {
      box-sizing: border-box;
      margin-left: .56rem;

      & > span {
        display: inline-block;
        width: 0.4rem;
        height: 0.04rem;
        background: #d9d9d9;
        margin-left: 0.04rem;
        box-sizing: border-box;
      }

      p {
        font-size: 0.24rem;
        color: #666;
        line-height: 0.4rem;
        margin-left: 0.04rem;

        & > span {
          color: #e80830;
            font-weight: 900;
        }
      }
    }
  }
}

.fd_login {
  width: 100%;
  padding: 0 0.3rem;
  box-sizing: border-box;

  h2 {
    height: 1rem;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    color: #666;

    i {
      margin-right: 0.2rem;
    }
  }

  p {
    font-size: 0.28rem;
    color: #333;
    line-height: 0.5rem;
    font-weight: 600;
    margin-bottom: 0.2rem;
  }

  .login_ipt {
    width: 100%;
    height: 0.7rem;
    border: 0.01rem solid #ccc;
    border-radius: 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.1rem 0 0.2rem;
    box-sizing: border-box;

    .ipt {
      font-size: .26rem;
      border: none;
      outline: none;
    }

    span {
      display: inline-block;
      width: 26%;
      height: 0.55rem;
      line-height: 0.55rem;
      background: #e7022b;
      text-align: center;
      color: #fff;
      border-radius: 0.06rem;
    }
  }

  .login_btn {
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    color: #fff;
    font-size: 0.26rem;
    background: #e7022b;
    margin-top: 0.4rem;
    border: none;
    border-radius: 0.06rem;
  }
}

.findShop_tip {
  width: 100%;
  text-align: center;
  line-height: 1.2rem;
  font-size: 0.26rem;
  color: #333;
  white-space: 0.02rem;

  span {
    color: #c90524;
  }
}
</style>